/**
 * @class Vimeo Video
 * 
 * @method constructor
 *     @param {HTMLElement} el
 * 
 * @method playVideo
 * @method pauseVideo
 * @method setToggleText
 * @method init
 *
 * Create a Vimeo iframe
 */

import Player from '@vimeo/player';

const selectors = {
    container: '.js-video-container',
    trigger: '.js-video-trigger'
}

const classes = {
    playing: 'is-playing',
    ready: 'is-ready'
}

export default class VimeoVideo {
    constructor (el) {
        this.el = el;
        this.container = el.querySelector(selectors.container);
        this.trigger = el.querySelector(selectors.trigger);
        this.player = null;

        this.isPlaying = false;

        this.init();
    }

    playVideo () {
        if (!this.player) return;

        this.player.play();
        this.el.classList.add(classes.playing);
        this.isPlaying = true;
    }

    pauseVideo () {
        if (!this.player) return;

        this.player.pause();
        this.el.classList.remove(classes.playing);
        this.isPlaying = false;
    }

    setToggleText () {
        this.label.innerText = this.isOpen ? this.toggle.dataset.closeText : this.toggle.dataset.openText;
    }

    init () {
        this.player = new Player(this.container);
        this.el.classList.add(classes.ready);
        this.trigger.addEventListener('click', () => {
            this.playVideo();
        });
    }
}
